module.exports = {
  email: "panicrazia@gmail.com",
};
